import Link from "next/link";
import { usePathname } from "next/navigation";

import { Stack } from "@/components/ui/stack";

import type { NavigationLinkItemProp } from "@/config/nav";
import { cn } from "@/lib/utils";

import { Button } from "../ui/button";

export function NavigationLinkItem({
  item,
  fullWidth = false,
}: {
  item: NavigationLinkItemProp;
  fullWidth?: boolean;
}) {
  const pathname = usePathname();
  // asChild: <button><a> is invalid HTML and iOS Safari drops the tap.
  return (
    <Button
      asChild
      variant={item.variant ?? "link"}
      size="sm"
      className={cn("text-sm", fullWidth && "w-full")}
    >
      <Link
        href={item.href}
        className={cn(
          "transition-colors hover:text-foreground/80",
          pathname?.startsWith(item.href)
            ? "text-foreground"
            : "text-foreground/80",
        )}
      >
        <Stack direction="row" align="center" gap={2}>
          {item.icon}
          {item.label}
        </Stack>
      </Link>
    </Button>
  );
}
